import script from "./profit.vue?vue&type=script&setup=true&lang=js"
export * from "./profit.vue?vue&type=script&setup=true&lang=js"

import "./profit.vue?vue&type=style&index=0&id=74482d50&lang=less&scoped=true"

import exportComponent from "D:\\liang_front_end\\agent-yuyooke\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74482d50"]])

export default __exports__